import { useContext, useState, useEffect, createContext } from 'react';

import { useSelector } from 'react-redux';

const FeatureFlagContext = createContext({});
FeatureFlagContext.displayName = 'FeatureFlagContext';

export const FeatureFlagProvider = ({ children }) => {
  const [featureFlags, setFeatureFlags] = useState({});
  const fetchedFeatureFlags = useSelector((state) => state.me.feature_flags);

  useEffect(() => {
    const processedFeatureFlags = (fetchedFeatureFlags || []).reduce((obj, featureFlag) => {
      return { ...obj, [`${featureFlag.name}`]: featureFlag.is_active };
    }, {});

    setFeatureFlags(processedFeatureFlags);
  }, [fetchedFeatureFlags, setFeatureFlags]);

  return <FeatureFlagContext.Provider value={featureFlags}>{children}</FeatureFlagContext.Provider>;
};

const useFeatureFlag = () => {
  const featureFlags = useContext(FeatureFlagContext);

  return featureFlags;
};

export default useFeatureFlag;
